import React from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import './assets/css/nucleo-icons.css'
import './assets/css/nucleo-svg.css'
import './assets/css/style.css'
import 'react-toastify/dist/ReactToastify.css'
import 'bootstrap/dist/js/bootstrap.bundle.min'

import { routeTree } from './routeTree.gen'

const router = createRouter({
  routeTree,
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

/**
 * Renders the React application to the DOM.
 */
let rootElement = document.getElementById('root');
if (!rootElement) {
  const div = document.createElement('div');
  div.id = 'root';
  document.body.insertBefore(div, document.body.firstChild);
  rootElement = div;
}
const hasRealServerHtml =
  rootElement.hasChildNodes() &&
  !(rootElement.childNodes.length === 1 &&
    rootElement.firstChild?.nodeType === Node.COMMENT_NODE &&
    (rootElement.firstChild.textContent || '').trim() === 'app-html');
if (hasRealServerHtml) {
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <RouterProvider router={router} />
    </React.StrictMode>
  );
} else {
  rootElement.innerHTML = '';
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <RouterProvider router={router} />
    </React.StrictMode>
  );
}
